// extracted by mini-css-extract-plugin
module.exports = {"quoteContainer":"NewSubmissionPage_quoteContainer__3DwmU","buttonFooter":"NewSubmissionPage_buttonFooter__NZtlk","buttonStyle":"NewSubmissionPage_buttonStyle__2ICph"};